import { render, staticRenderFns } from "./stepsFour.vue?vue&type=template&id=fb396590&scoped=true"
import script from "./stepsFour.vue?vue&type=script&lang=js"
export * from "./stepsFour.vue?vue&type=script&lang=js"
import style0 from "./stepsFour.vue?vue&type=style&index=0&id=fb396590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb396590",
  null
  
)

export default component.exports